<div>
	<p-dialog [(visible)]="visible" (onHide)="onDialogHide()" [modal]="true" 
			  [style]="{'width': '900px', 'height': (create ? '910px' : '710px')}"
			  [resizable]="false" appendTo="body">

		<p-header>
			<span>{{dialogTitle}}</span>
		</p-header>

		<div style="overflow: hidden">
			<directory-user [target]="target" [create]="create" [userType]="userType" [domains]="domains"
							[allowSearch]="allowSearch" [dirUsers]="dirUsers">
			</directory-user>
		</div>

		<p-footer>
			<button type="button" pButton icon="fa fa-check" [disabled]="!enableOk" (click)="onOkClicked()" label="OK"></button>
			<button type="button" pButton icon="fa fa-close" (click)="onCancelClicked()" label="Cancel"></button>
		</p-footer>

	</p-dialog>
</div>
